module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00038))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00039))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00040))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00041))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.filteredCarModelList), function(model) {
    return _c('div', {
      key: model.CarModelGuid,
      staticClass: "wizard-table-row",
      class: {
        'invalid-wizard-table-row': _vm.multipleModels.has(model.CarModelName)
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('div', [_vm._l((_vm.importerList), function(importer) {
      return [(importer.ImporterGuid === model.ImporterGuid) ? _c('div', {
        key: importer.ImporterGuid
      }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', _vm._l((model.CarSegments), function(modelCarSegment, index) {
      return _c('span', {
        key: modelCarSegment.CarSegmentGuid
      }, [_vm._l((_vm.segmentList), function(segment) {
        return [(
          segment.CarSegmentGuid ===
          modelCarSegment.CarSegmentGuid
        ) ? _c('span', {
          key: segment.CarSegmentGuid
        }, [(index != 0) ? _c('span', [_vm._v(" ,")]) : _vm._e(), _vm._v("\n                  " + _vm._s(segment.CarSegmentName) + "\n                ")]) : _vm._e()]
      })], 2)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.Distribution),
        expression: "model.Distribution",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "number",
        "min": 0,
        "max": 100,
        "step": 0.1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (model.Distribution)
      },
      on: {
        "change": function($event) {
          return _vm.validateDistributionValue(model)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "Distribution", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sum-display"
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.W00071) + " " + _vm._s(_vm.sumDistribution) + "%")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff88364c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step3.vue
// module id = 1742
// module chunks = 1